import _ from "underscore";
import * as aj from "../aj/index";
import { SURVEYS } from "./types";
import * as actions from "../actions/types";
import { completed, failed } from "../utils/ajex";
import * as SurveyUtils from "../web/utils/surveys";
import * as CustomUtils from "../utils/customUtils";
import { isEmpty, isNotEmpty } from "../framework/utils";
import { optional } from "../utils/lang";
import deepmerge from "deepmerge";

export function getDefaultState() {
    return {
        openSurveys: {
            rows: [],
            totalRows: 0,
        },
        userSurveys: {
            rows: [],
            totalRows: 0,
        },
        currentSurvey: {},
        surveysStats: [],
    }
}

function applyScoresAndRatings(state, scores, ratings) {
    const updatedState = CustomUtils.deepClone(state),
        currentSurvey = optional(updatedState.currentSurvey, {}),
        lastSurveyScore = _.find(scores, s => isEmpty(s.categoryId));

    function applyScoreToSurveys(surveys, score) {
        _.chain(surveys.rows)
            .filter(s => s.survey.id === score.surveyId)
            .each(s => {
                s.survey.lastScore = score;
            })
    }

    SurveyUtils.applyScores(currentSurvey.roots, scores);
    SurveyUtils.applyRatings(currentSurvey.roots, ratings);

    if (isNotEmpty(lastSurveyScore)) {
        currentSurvey.survey.lastScore = lastSurveyScore;
        applyScoreToSurveys(state.openSurveys, lastSurveyScore);
        applyScoreToSurveys(state.userSurveys, lastSurveyScore);
    }

    return updatedState
}

export const SurveysStore = aj.createStore(SURVEYS, (state = getDefaultState(), action) => {
    let currentSurvey;

    switch(action.type) {
        case completed(actions.GET_OPEN_SURVEYS):
            return _.assign(state, {openSurveys: action.openSurveys});
        case completed(actions.GET_USER_SURVEYS):
            return _.assign(state, {userSurveys: action.userSurveys});
        case completed(actions.LOAD_SURVEY):
            currentSurvey = action.questionsTree;
            currentSurvey.users = action.surveyUsers;
            return _.assign(
                    state,
                    applyScoresAndRatings(
                        _.assign(state, {currentSurvey: currentSurvey}),
                        action.surveyScores,
                        action.surveyRatings
                    )
                );
        case actions.CLEAR_SURVEY:
            return _.assign(state, {currentSurvey: {}});
        case completed(actions.SET_SURVEY_RATING):
            return _.assign(
                    state,
                    applyScoresAndRatings(state, action.surveyScores, action.surveyRatings)
                );
        case completed(actions.SET_SURVEY_RATING_NOTES):
        case completed(actions.ADD_RATING_PHOTOS):
        case completed(actions.DELETE_RATING_PHOTOS):
            return _.assign(
                state,
                applyScoresAndRatings(state, [], action.surveyRatings)
            );
        case completed(actions.GET_SURVEY_USERS):
            currentSurvey = deepmerge(state.currentSurvey, {users: action.surveyUsers});
            currentSurvey.users = _.uniq(
                    optional(currentSurvey.users, []),
                    false,
                    u => u.id
                );

            return _.assign(state, {currentSurvey: currentSurvey})
        case completed(actions.CLOSE_SURVEY): 
            return _.assign(state, {})
        case completed(actions.REOPEN_SURVEY): 
            return _.assign(state, {})
        case completed(actions.GET_SURVEYS_STATS):
            return _.assign(state, {surveysStats: action.surveysStats})
    }

})